import { ExportColumn } from '../services/helpers/csvExport';
import { generateOrderTanHeaders, CsvColumnMeta } from '../components/molecules/HeaderColumns/OrderColumnHeaders';

const buildExportColumnsFromHeaders = (): ExportColumn[] => {
    const headers = generateOrderTanHeaders([]);

    return headers
        .filter(col => (col.meta as { csv?: CsvColumnMeta })?.csv)
        .map(col => {
            const csv = (col.meta as { csv: CsvColumnMeta }).csv;
            const tableHeader = (col.header as string) ?? '';
            return {
                key: (col as { accessorKey?: string }).accessorKey ?? col.id ?? tableHeader,
                label: csv.label,
                tableHeader,
                accessor: csv.accessor,
            };
        });
};

const orderExportColumns: ExportColumn[] = buildExportColumnsFromHeaders();

export default orderExportColumns;
